import * as types from '../mutation-types';
import adverts from '../../api/adverts';
import _ from 'lodash';

const state = {
  adverts: [],
  selectedAdvert: null,
  exclusions: []
};

const getters = {
  Adverts: state => state.adverts,
  SelectedAdvert: state => _.clone(_.find(state.adverts, advert => advert.id === state.selectedAdvert)),
  AdvertExclusions: state => state.exclusions
};

const actions = {
  getAdverts({ commit, dispatch }) {
    adverts
      .getAdverts()
      .then(response => {
        commit(types.GET_ADVERTS, response.data);
        if (response.data.length > 0) {
          dispatch('selectAdvert', response.data[0].id);
        }
      })
      .catch(error => console.error(error));
  },
  createAdvert({ commit }, advert) {
    adverts.createAdvert(advert).then(response => commit(types.CREATE_ADVERT, response));
  },
  updateAdvert({ commit }, advert) {
    adverts.updateAdvert(advert);
    commit(types.UPDATE_ADVERT, advert);
  },
  // deleteAdvert({ commit, dispatch }, advert) {},
  selectAdvert({ commit, dispatch }, id) {
    commit(types.SET_SELECTED_ADVERT, id);
    dispatch('getAdvertExclusions', { id });
  },
  getAdvertExclusions({ commit }, { id }) {
    adverts.getExclusions(id).then(response => commit(types.GET_ADVERT_EXCLUSIONS, response.excluded_partners));
  },
  excludeAdvertPartner({ commit }, { advertId, partner }) {
    adverts.excludePartner(advertId, partner.id).catch(error => console.error(error));
    commit(types.ADVERT_EXCLUDE_PARTNER, partner);
  },
  includeAdvertPartner({ commit }, { advertId, partner }) {
    adverts.includePartner(advertId, partner.id).catch(error => console.error(error));
    commit(types.ADVERT_INCLUDE_PARTNER, partner);
  }
};

const mutations = {
  [types.GET_ADVERTS](state, adverts) {
    state.adverts = _.sortBy(adverts, 'name');
  },
  [types.SET_SELECTED_ADVERT](state, id) {
    state.selectedAdvert = id;
  },
  [types.CREATE_ADVERT](state, advert) {
    state.adverts = [...state.adverts, advert];
  },
  [types.UPDATE_ADVERT](state, updatedAdvert) {
    const adverts = _.clone(state.adverts);
    const index = _.findIndex(adverts, advert => advert.id === updatedAdvert.id);
    if (index >= 0) {
      adverts[index] = updatedAdvert;
    }
    state.adverts = adverts;
  },
  [types.GET_ADVERT_EXCLUSIONS](state, exclusions) {
    this.state.exclusions = exclusions;
  },
  [types.ADVERT_EXCLUDE_PARTNER](state, partner) {
    state.exclusions = [...state.exclusions, partner];
  },
  [types.ADVERT_INCLUDE_PARTNER](state, partner) {
    const exclusions = _.clone(state.exclusions);
    const index = _.findIndex(exclusions, p => p.id === partner.id);
    if (index >= 0) {
      exclusions.splice(index, 1);
    }
    state.exclusions = exclusions;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
